import { activateKey } from "api/user";
import Loader from "components/Loader";
import { ApiResponse } from "constantVariables";
import { t } from "i18next";
import { useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { showToast } from "utils/toast";

export default function ActivateKey() {
  const [keyStatus, setKeyStatus] = useState({
    isLoading: true,
    message: "",
  });

  const { key } = useParams();
  const navigate = useNavigate();
  const { dir } = useAppSelector(getSettings);

  useLayoutEffect(() => {
    if (key) {
      activateKey(key)
        .then((res) => {
          if (res.statusCode === ApiResponse.SUCCESS) {
            showToast(t("keyActivatedSuccessfully"));
            navigate("/user-auth/login", {
              state: { success: t("keyActivatedSuccessfully") },
            });
          } else if (res.statusCode === ApiResponse.CONFLICT) {
            showToast(t("keyAlreadyActivated"));
            navigate("/user-auth/login", {
              state: { error: t("keyAlreadyActivated") },
            });
          } else {
            throw new Error(res.message);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setKeyStatus({
            isLoading: false,
            message:
              "Cannot activate key at the moment, please try again later.",
          });
        });
    }
  }, [key]);

  if (!keyStatus.isLoading)
    return (
      <Loader
        open={true}
        className="bg-transparent"
        loaderClassName="!border-t-theme-blue"
        message={t("keyActivating")}
      />
    );
  return (
    <div
      className="flex items-center justify-center h-screen w-screen"
      dir={dir}
    >
      <p>{keyStatus.message}</p>
    </div>
  );
}
